import JWTinterceptor from "@/services/axios";


export async function getNewTopicIdService(ehrEncounterId){
    try {
        const response = await JWTinterceptor.post(`last_chat`,{
        encounter_id: ehrEncounterId
        });
        return response.data.responseData;   
    } catch(err){
        console.error("Get new topic id Error:",err);
        throw err;
    }
}
export async function getTopicChatService(topicId){
    try {
        const response = await JWTinterceptor.get(`chat/${topicId}/messages`,{
        topic_id: topicId
        });
        return response.data;   
    } catch(err){
        console.error("Get topic chat Error:",err);
        throw err;
    }
}
export async function getTopicListService(page, dialogId){
    try {
        const response = await JWTinterceptor.get(`chat/${dialogId}/${page}/10`);
        return response.data;   
    } catch(err){
        console.error("Get topic list Error:",err);
        throw err;
    }
}
export async function searchEncountersService(searchQuery){
    try{
        const response = await JWTinterceptor.get(`search_chat/${searchQuery}/1/10`); 
        return response.data?.responseData;
    } catch(err){
        console.error("Search encounters Error:",err);
        throw err;
    }
}
export async function getEncounterByIdService(patient_id) {
    try {
      const res = await JWTinterceptor.post(`get_patient_encounters`,
        {
          patient_id: patient_id,
        }
      );
      return res.data.data;
    } catch (err) {
      console.error("Get encounter by ID error:", err);
      throw err; 
    }
}